export const storagePaths = {
  /**
   * temporary uploaded user files.
   *
   */
  userTmpDir: '/tmp/',
}
